export default __webpack_public_path__ + "static/media/pedaIcon.1a8fcf12.svg";